import { useMemo } from 'react';
import { BANNER_ADS } from '../parody-data.js';

const NAV_LINKS = [
  { label: 'Video',       site: 'youtoob' },
  { label: 'People',      site: 'myface' },
  { label: 'Games',       site: 'megafunzone' },
  { label: 'Music',       site: 'winampgalaxy' },
  { label: 'Surprise Me', site: 'randomsite' },
];

const NEWS = [
  { cat: 'TECH',  text: 'Vista SP1 Delayed Again; Microsoft Cites "Final Testing Phase"',             time: '1h ago' },
  { cat: 'WEB',   text: 'FaceLeak Crosses 50 Million Profiles; Updates Terms of Service (pg. 47)',    time: '2h ago' },
  { cat: 'VIDEO', text: 'YouBoob Clip Sets Record: 12.8 Million Views in a Single Day',               time: '3h ago' },
  { cat: 'ENT',   text: 'Britney Spears Hospitalized; Nation Refreshes Gossip Blogs',                 time: '4h ago' },
  { cat: 'BIZ',   text: 'Online Ad Revenue Up 35%; Toolbar Downloads Hit All-Time High',              time: '5h ago' },
  { cat: 'TECH',  text: 'Apple Announces "iPhone" — Industry Experts Skeptical',                      time: '6h ago' },
];

const HOT_SEARCHES = [
  'faceleak layouts', 'free ringtones download', 'paris hilton',
  'youboob funny clips', 'chuck norris facts', 'britney spears',
  'how to remove spyware', 'vista release date',
];

const DESTINATIONS = [
  { id: 'youtoob',     icon: 'VID', cls: 'pdest-red',    label: 'YouBoob',        desc: 'Watch the most viewed clips on the web' },
  { id: 'myface',      icon: 'SOC', cls: 'pdest-blue',   label: 'FaceLeak',       desc: 'Your profile. Your data. Our revenue.' },
  { id: 'megafunzone', icon: 'GME', cls: 'pdest-green',  label: 'MegaFunExploit', desc: 'Flash games. Free. (Terms apply.)' },
  { id: 'winampgalaxy',icon: 'MP3', cls: 'pdest-purple', label: 'WinScam Galaxy', desc: 'Download music. Probably legal.' },
];

const DIR_COLS = [
  {
    heading: 'Entertainment',
    links: [
      { label: 'Videos',          site: 'youtoob' },
      { label: 'Flash Games',     site: 'megafunzone' },
      { label: 'Music Downloads', site: 'winampgalaxy' },
      { label: 'Celebrity Gossip' },
      { label: 'Movie Showtimes' },
      { label: 'TV Listings' },
    ],
  },
  {
    heading: 'Technology',
    links: [
      { label: 'Free Downloads' },
      { label: 'Screensavers' },
      { label: 'Browser Toolbars' },
      { label: 'Spyware Removal' },
      { label: 'Driver Updates' },
      { label: 'Broadband Guide' },
    ],
  },
  {
    heading: 'Lifestyle',
    links: [
      { label: 'Horoscopes' },
      { label: 'Weight Loss Tips' },
      { label: 'Online Recipes' },
      { label: 'Dating & Personals' },
      { label: 'Home & Garden' },
      { label: 'Parenting Online' },
    ],
  },
  {
    heading: 'Finance',
    links: [
      { label: 'Stock Quotes' },
      { label: 'Mortgage Rates' },
      { label: 'Online Banking' },
      { label: 'Credit Reports' },
      { label: 'Tax Preparation' },
      { label: 'Insurance Quotes' },
    ],
  },
];

export const PortalPage = ({ onNavigate }) => {
  const adTop  = useMemo(() => BANNER_ADS[Math.floor(Math.random() * BANNER_ADS.length)], []);
  const adSide = useMemo(() => BANNER_ADS[Math.floor(Math.random() * BANNER_ADS.length)], []);

  const nav = (site, e) => { e.preventDefault(); if (site) onNavigate(site); };

  return (
    <div className="portal-page" data-testid="portal-page">

      {/* Utility bar */}
      <div className="portal-util-bar">
        <span>The Information Superhighway™ — Your Gateway to the Internet</span>
        <span className="portal-util-right">
          <a href="#">Sign In</a>
          <span className="util-pipe">|</span>
          <a href="#">My Account</a>
          <span className="util-pipe">|</span>
          <a href="#">Help</a>
          <span className="util-pipe">|</span>
          <a href="#">Make This My Home Page</a>
        </span>
      </div>

      {/* Header */}
      <div className="portal-header">
        <div className="portal-logo-area">
          <div className="portal-logo-text">
            <span className="logo-info">info</span><span className="logo-super">SUPER</span><span className="logo-highway">highway</span><span className="logo-tm">.net</span>
          </div>
          <div className="portal-logo-tagline">Connect &bull; Explore &bull; Download Toolbars&trade;</div>
        </div>
        <div className="portal-header-search">
          <div className="portal-search-row">
            <input type="text" className="portal-search-input" placeholder="Search the Web with AskJerves&trade;" />
            <button className="portal-search-btn">Search</button>
          </div>
          <div className="portal-search-tabs">
            <a href="#">Web</a>
            <a href="#">Images</a>
            <a href="#">News</a>
            <a href="#">Local</a>
            <a href="#">Shopping</a>
          </div>
        </div>
        <div className="portal-header-right">
          <div className="portal-visitor-count">Visitor #<span className="portal-counter">1,337,420</span></div>
          <div className="portal-date">Thu, Mar 15, 2007</div>
          <div className="portal-temp">72&deg;F &mdash; Partly Cloudy</div>
        </div>
      </div>

      {/* Nav bar */}
      <div className="portal-nav-bar">
        <div className="portal-nav-left">
          {NAV_LINKS.map(nl => (
            <a key={nl.site} href="#" onClick={e => nav(nl.site, e)} className="portal-nav-link">{nl.label}</a>
          ))}
          <span className="portal-nav-pipe">|</span>
          <a href="#" className="portal-nav-link">Mail</a>
          <a href="#" className="portal-nav-link">News</a>
          <a href="#" className="portal-nav-link">Finance</a>
          <a href="#" className="portal-nav-link">Sports</a>
          <a href="#" className="portal-nav-link">Travel</a>
          <a href="#" className="portal-nav-link">Shopping</a>
        </div>
        <div className="portal-nav-ad blinking" style={{ color: adTop.color }}>
          {adTop.text}
        </div>
      </div>

      {/* Main 3-column table */}
      <table className="portal-table">
        <tbody>
          <tr>

            {/* LEFT SIDEBAR */}
            <td className="portal-col-left">

              <div className="pmodule">
                <div className="pmodule-hd">Quick Links</div>
                <div className="pmodule-bd">
                  <ul className="plink-list">
                    {DESTINATIONS.map(d => (
                      <li key={d.id}>
                        <a href="#" onClick={e => nav(d.id, e)}>&rsaquo; {d.label}</a>
                      </li>
                    ))}
                    <li><a href="#" onClick={e => nav('randomsite', e)}>&rsaquo; Random Site!</a></li>
                  </ul>
                </div>
              </div>

              <div className="pmodule">
                <div className="pmodule-hd">Hot Searches</div>
                <div className="pmodule-bd">
                  <ol className="phot-searches">
                    {HOT_SEARCHES.map((s, i) => <li key={i}>{s}</li>)}
                  </ol>
                </div>
              </div>

              <div className="pmodule-sponsor blinking" style={{ color: adSide.color }}>
                <div className="pmodule-sponsor-text">{adSide.text}</div>
                <div className="pmodule-sponsor-sub">{adSide.subtext}</div>
                <button className="pmodule-sponsor-btn">Click Here!</button>
              </div>

              <div className="pmodule">
                <div className="pmodule-hd">Community</div>
                <div className="pmodule-bd">
                  <ul className="plink-list">
                    <li><a href="#">&rsaquo; Chat Rooms</a></li>
                    <li><a href="#">&rsaquo; Message Boards</a></li>
                    <li><a href="#">&rsaquo; Member Photos</a></li>
                    <li><a href="#">&rsaquo; Groups</a></li>
                    <li><a href="#">&rsaquo; Classifieds</a></li>
                  </ul>
                </div>
              </div>

              <div className="pmodule">
                <div className="pmodule-hd">Tools</div>
                <div className="pmodule-bd">
                  <ul className="plink-list">
                    <li><a href="#">&rsaquo; Free E-mail</a></li>
                    <li><a href="#">&rsaquo; Instant Messenger</a></li>
                    <li><a href="#">&rsaquo; Toolbar Download</a></li>
                    <li><a href="#">&rsaquo; Screensavers</a></li>
                    <li><a href="#">&rsaquo; Smileys &amp; Icons</a></li>
                  </ul>
                </div>
              </div>

            </td>

            {/* CENTER MAIN */}
            <td className="portal-col-main">

              {/* Top Stories */}
              <div className="pmodule">
                <div className="pmodule-hd pmodule-hd-flex">
                  <span>Today&rsquo;s Top Stories</span>
                  <a href="#" className="pmodule-more">More News &raquo;</a>
                </div>
                <div className="pmodule-bd">
                  {NEWS.map((item, i) => (
                    <div key={i} className="pnews-item">
                      <span className="pnews-cat">{item.cat}</span>
                      <a href="#" className="pnews-link">{item.text}</a>
                      <span className="pnews-time">{item.time}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Featured Destinations */}
              <div className="pmodule">
                <div className="pmodule-hd pmodule-hd-flex">
                  <span>Featured Destinations</span>
                  <a href="#" className="pmodule-more">All Sites &raquo;</a>
                </div>
                <div className="pmodule-bd">
                  <div className="pdest-grid">
                    {DESTINATIONS.map(d => (
                      <div
                        key={d.id}
                        className="pdest-item"
                        onClick={() => onNavigate(d.id)}
                        data-testid={`portal-${d.id}`}
                      >
                        <div className={`pdest-icon ${d.cls}`}>{d.icon}</div>
                        <div className="pdest-info">
                          <div className="pdest-label">{d.label}</div>
                          <div className="pdest-desc">{d.desc}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Breaking ticker */}
              <div className="pbreaking">
                <span className="pbreaking-label">BREAKING</span>
                <marquee scrollamount="3" className="pbreaking-ticker">
                  Apple announces "iPhone" &mdash; experts predict it will never catch on &bull;
                  FaceLeak TOS updated (see page 47, clause 12b, subparagraph iii) &bull;
                  Chocolate Rain Man reportedly signs with a label &bull;
                  Vista: Still Loading. Please Wait. &bull;
                  YouBoob adds pre-roll ad to every clip &bull;
                  Flash game addiction now recognized as medical condition &bull;
                  WinScam Galaxy settles with RIAA; 14 new songs added
                </marquee>
              </div>

              {/* Web Directory */}
              <div className="pmodule">
                <div className="pmodule-hd">Web Directory</div>
                <div className="pmodule-bd">
                  <div className="pdir-grid">
                    {DIR_COLS.map(col => (
                      <div key={col.heading} className="pdir-col">
                        <div className="pdir-heading">{col.heading}</div>
                        {col.links.map(lk => (
                          <a
                            key={lk.label}
                            href="#"
                            onClick={lk.site ? e => nav(lk.site, e) : e => e.preventDefault()}
                          >
                            {lk.label}
                          </a>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </td>

            {/* RIGHT SIDEBAR */}
            <td className="portal-col-right">

              <div className="pmodule">
                <div className="pmodule-hd">Weather</div>
                <div className="pmodule-bd pweather">
                  <div className="pweather-city">Your City, USA</div>
                  <div className="pweather-temp">72&deg;F</div>
                  <div className="pweather-cond">Partly Cloudy</div>
                  <div className="pweather-hi-lo">H: 78&deg; &nbsp; L: 61&deg;</div>
                  <div className="pweather-zip">
                    <input type="text" placeholder="ZIP code" className="pweather-input" />
                    <button className="pweather-btn">Go</button>
                  </div>
                </div>
              </div>

              <div className="pmodule">
                <div className="pmodule-hd">Your Stars</div>
                <div className="pmodule-bd phoroscope">
                  <select className="phoroscope-select" defaultValue="Gemini">
                    {['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'].map(s => (
                      <option key={s}>{s}</option>
                    ))}
                  </select>
                  <p className="phoroscope-text">
                    A strong cosmic alignment suggests updating your FaceLeak profile today.
                    Avoid large file downloads after 3&nbsp;PM. Lucky toolbar: AskJerves&trade;.
                    Financial outlook: moderate (pending Vista activation).
                  </p>
                </div>
              </div>

              <div className="pmodule">
                <div className="pmodule-hd">Today&rsquo;s Top Sites</div>
                <div className="pmodule-bd">
                  <ol className="ptopsites">
                    {DESTINATIONS.map((d, i) => (
                      <li key={d.id}><a href="#" onClick={e => nav(d.id, e)}>{d.label}</a></li>
                    ))}
                    <li><a href="#">eBuy Auctions</a></li>
                    <li><a href="#">AskJerves Search</a></li>
                  </ol>
                </div>
              </div>

              <div className="pmodule">
                <div className="pmodule-hd">Daily Poll</div>
                <div className="pmodule-bd">
                  <p className="ppoll-q">Best web browser? (Results shared with 14 ad partners.)</p>
                  <div className="ppoll-options">
                    <label><input type="radio" name="poll" /> Internet Exploder 6</label>
                    <label><input type="radio" name="poll" /> FireFoxx 2.0</label>
                    <label><input type="radio" name="poll" /> Netscape Navigator</label>
                    <label><input type="radio" name="poll" /> AOL Browser</label>
                  </div>
                  <button className="ppoll-btn">Vote!</button>
                </div>
              </div>

              <div className="pmodule-sponsor blinking" style={{ backgroundColor: '#000033', color: '#FFD700' }}>
                <div className="pmodule-sponsor-text">YOU ARE VISITOR #1,000,000</div>
                <div className="pmodule-sponsor-sub">Claim your FREE desktop toolbar!</div>
                <button className="pmodule-sponsor-btn">CLAIM PRIZE</button>
              </div>

            </td>

          </tr>
        </tbody>
      </table>

      {/* Footer */}
      <div className="portal-footer">
        <div className="portal-footer-links">
          <a href="#">About Us</a> | <a href="#">Advertise With Us</a> | <a href="#">Privacy Policy</a> |
          <a href="#">Terms of Service</a> | <a href="#">Contact Us</a> |
          <a href="#">Webmaster Tools</a> | <a href="#">Site Map</a> | <a href="#">Help</a>
        </div>
        <div className="portal-footer-cats">
          Web &middot; News &middot; Entertainment &middot; Finance &middot; Sports &middot; Travel &middot;
          Shopping &middot; Health &middot; People &middot; Games &middot; Music &middot; Local &middot; Weather
        </div>
        <div className="portal-footer-copy">
          &copy; 2007 InfoSuperHighway&trade; &mdash; A Profit Dynamics International&trade; Company. All Rights Reserved.<br />
          Best viewed in Internet Exploder 6.0 at 800&times;600. Some features require Flash Player 8 or higher.
          Use of this site constitutes acceptance of our <a href="#">Privacy Policy</a> and <a href="#">Terms of Service</a>.
        </div>
        <div className="portal-footer-badges">
          <span className="portal-badge">SECURE SITE</span>
          <span className="portal-badge">BROADBAND READY</span>
          <span className="portal-badge">WEB AWARD 2006</span>
          <span className="portal-badge">AOL COMPATIBLE</span>
          <span className="portal-badge">UNDER CONSTRUCTION</span>
        </div>
      </div>

    </div>
  );
};

export default PortalPage;
